module.exports = __webpack_public_path__ + "kids_classic-sport_1.jpg";